import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { searchSpinner, updateQueryStringParameter, getRexDocuments } from './custom-functions.js'
import { Splide } from '@splidejs/splide';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { init } from "shareon";

init();

// Splide
if (document.querySelector('.splide')) {
	if (document.querySelector('.rcreviews--section')) {
		new Splide('.rcreviews--section', {
			perPage: 2,
			perMove: 1,
			rewind: true,
			gap: '32px',
			pagination: false,
			autoplay: true,
			interval: 3000,
			breakpoints: {
				1151: {
					perPage: 1,
				},
			},
			classes: {
				prev: 'splide__arrow--prev rcreviews-prev',
				next: 'splide__arrow--next rcreviews-next',
			},
		}).mount();
	}
	if (document.querySelector('.suburbs--section')) {
		new Splide('.suburbs--section', {
			perPage: 4,
			perMove: 1,
			rewind: true,
			gap: '32px',
			pagination: false,
			autoplay: true,
			interval: 3000,
			breakpoints: {
				1151: {
					perPage: 1,
				},
			},
			classes: {
				prev: 'splide__arrow--prev suburbs-prev',
				next: 'splide__arrow--next suburbs-next',
			},
		}).mount();
	}
	if (document.querySelector('.teams--section')) {
		new Splide('.teams--section', {
			perPage: 3,
			perMove: 1,
			rewind: true,
			gap: '64px',
			pagination: false,
			autoplay: true,
			interval: 3000,
			breakpoints: {
				1151: {
					perPage: 2,
				},
				767: {
					perPage: 1,
				},
			},
			classes: {
				prev: 'splide__arrow--prev teams-prev',
				next: 'splide__arrow--next teams-next',
			},
		}).mount();
	}
}

document.addEventListener('DOMContentLoaded', function () {
	// Bind to the "Previous" button
	const customPrevButtons = document.querySelectorAll('.rcreviews-btn-prev');
	customPrevButtons.forEach(button => {
		button.addEventListener('click', function () {
			const splidePrevButton = document.querySelector('.rcreviews-prev');
			if (splidePrevButton) {
				splidePrevButton.click();
			}
		});
	});

	// Bind to the "Next" button
	const customNextButtons = document.querySelectorAll('.rcreviews-btn-next');
	customNextButtons.forEach(button => {
		button.addEventListener('click', function () {
			const splideNextButton = document.querySelector('.rcreviews-next');
			if (splideNextButton) {
				splideNextButton.click();
			}
		});
	});

	// Bind to the "Previous" button
	const customPrevButtons2 = document.querySelectorAll('.suburbs-btn-prev');
	customPrevButtons2.forEach(button2 => {
		button2.addEventListener('click', function () {
			const splidePrevButton2 = document.querySelector('.suburbs-prev');
			if (splidePrevButton2) {
				splidePrevButton2.click();
			}
		});
	});

	// Bind to the "Next" button
	const customNextButtons2 = document.querySelectorAll('.suburbs-btn-next');
	customNextButtons2.forEach(button2 => {
		button2.addEventListener('click', function () {
			const splideNextButton2 = document.querySelector('.suburbs-next');
			if (splideNextButton2) {
				splideNextButton2.click();
			}
		});
	});

	// Bind to the "Previous" button
	const customPrevButtons3 = document.querySelectorAll('.teams-btn-prev');
	customPrevButtons3.forEach(button2 => {
		button2.addEventListener('click', function () {
			const splidePrevButton3 = document.querySelector('.teams-prev');
			if (splidePrevButton3) {
				splidePrevButton3.click();
			}
		});
	});

	// Bind to the "Next" button
	const customNextButtons3 = document.querySelectorAll('.teams-btn-next');
	customNextButtons3.forEach(button2 => {
		button2.addEventListener('click', function () {
			const splideNextButton3 = document.querySelector('.teams-next');
			if (splideNextButton3) {
				splideNextButton3.click();
			}
		});
	});
});

// selectize all select elements with default settings.
let activeSelectize = null;
window.selectizeTheWorld = () => {

	jQuery('select:not(".unselectized"):not(".epl-sort-listings")').selectize({
		plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
		delimiter: ',',
		persist: false,
		create: function (input) {
			return {
				value: input, text: input,
			}
		},
		onDropdownOpen: function () {
			// Close the previously active selectize instance
			if (activeSelectize && activeSelectize !== this) {
				activeSelectize.close();
			}
			// Set the current instance as active
			activeSelectize = this;
		},
		onDropdownClose: function () {
			// Clear the active instance when dropdown is closed
			activeSelectize = null;
		},
	})
}

// Update the sort order when clicked.
window.changePropertySortOrder = () => {

	const sortOrder = document.getElementById('epl-sort-listings-');

	if (sortOrder) {
		jQuery('#epl-sort-listings-').selectize({
			onChange: function (value, isOnInitialize) {
				if (value !== '') {
					let url = window.location.href;
					let newUrl = updateQueryStringParameter(url, 'sortby', value);
					window.location.replace(newUrl);
				}
			}
		});
	}
}

/**
 * Once the page loads, do our stuff!
 */
document.addEventListener('DOMContentLoaded', function () {

	// Fix for the sort order tool from EPL on property archive pages.
	changePropertySortOrder();

	// Check for submit buttons and add spinner.
	searchSpinner();

	// Enables Selectize on all select elements.
	selectizeTheWorld();

	// Get Fancybox going.
	Fancybox.bind('[data-fancybox]', {})

	// Enable Tooltips for BootStrap 5.3.
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	tooltipTriggerList.forEach(tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl))

	// Get the contract link element, and if it exists, load the data when the dropdown is clicked.
	const documentLinks = document.getElementById('contract-links');
	if (documentLinks) {
		documentLinks.addEventListener('show.bs.dropdown', event => {
			getRexDocuments(documentLinks.dataset.id)
		});
	}

	//Floating form
	var input = document.querySelector('.floating-form .form-control');

	function checkInput() {
		if (input) {
			var label = input.closest('.gfield').querySelector('.form-label');
			if (input.value !== '' || input === document.activeElement) {
				label.classList.add('float-label');
			} else {
				label.classList.remove('float-label');
			}
		}
	}

	if (input) {
		input.addEventListener('focus', checkInput);
		input.addEventListener('blur', checkInput);
		input.addEventListener('input', checkInput);
	}

	// Initial check
	checkInput();

	function test() {
		return $.ajax({ // <----- Notice the return statement here
			url: url,
			type: 'GET',
			success: {
				if(input) {
					checkInput();
					input.addEventListener('focus', checkInput);
					input.addEventListener('blur', checkInput);
					input.addEventListener('input', checkInput);
				}
			}
		});
	}

});

//Reset Button - Unset Selectize
if (document.getElementById('btn-reset')) {
	document.getElementById('btn-reset').addEventListener('click', function () {
		var selectizeControls = document.querySelectorAll('.enable-clear .selectize-control');
		selectizeControls.forEach(function (selectizeControl) {
			var clearButton = selectizeControl.querySelector('.clear');
			if (clearButton) {
				clearButton.click();
			}
		});

		jQuery('.enable-clear input[type="radio"]').removeAttr('checked');
		jQuery('.dropdown-toggle--sort').text('Default');
	});
}

//Selectize - Copy Options
if (jQuery('#property_location_main-selectized')) {
	jQuery('#property_location_main-selectized').on('click', function () {
		var options = jQuery('#property_location option:selected').sort().clone();
		jQuery('#property_location').append(options);
	});
}
if (jQuery('#property_location-selectized')) {
	jQuery('#property_location-selectized').on('click', function () {
		var options = jQuery('#property_location_main option').sort().clone();
		jQuery('#property_location_main').append(options);
	});
}

jQuery(document).ready(function ($) {
	var inc = 0;
	if ($('#property_location_main')) {
		$('#property_location_main').selectize({
			plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
			onChange: function (value) {
				copySelectizeOptions(value, $('#property_location_main'), $('#property_location'));
			}
		});

	}
	if ($('#property_location')) {
		$('#property_location').selectize({
			plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
			onChange: function (value) {
				copySelectizeOptions(value, $('#property_location'), $('#property_location_main'));
			}
		});
	}

	function copySelectizeOptions(value, source, destination) {
		var $sourceSelect = source.selectize();
		var sourceSelectize = $sourceSelect[0].selectize;
		var selectedValues = sourceSelectize.getValue();

		var $destinationSelect = destination.selectize();
		var destinationSelectize = $destinationSelect[0].selectize;
		destinationSelectize.clear();

		selectedValues.forEach(function (value) {
			var option = sourceSelectize.getOption(value);
			destinationSelectize.addOption(option, true);
			destinationSelectize.addItem(value, true);
			sourceSelectize.addOption(option, true);
			sourceSelectize.addItem(value, true);
		});
	}
});

jQuery(document).ready(function ($) {
	if ($('.video-modal').length) {
		var modal = $('.video-modal');
		var iframe = modal.find('iframe');
		var urlsrc = new URL(iframe.attr('src'));

		if (modal.length) {

			modal.on('show.bs.modal', function () {
				urlsrc.searchParams.set('autoplay', 'true');
				iframe.attr('src', urlsrc.toString());
			})

			modal.on('hidden.bs.modal', function () {
				urlsrc.searchParams.set('autoplay', 'false');
				iframe.attr('src', '');
			})
		}
	}

	$(document).on('show.bs.modal', '.modal', function () {
		$(this).appendTo('body');
	});
});

//Google Maps
import { Loader } from "@googlemaps/js-api-loader"

if (document.querySelectorAll('input[name="auction_date"]')) {
	var auctionRadios = document.querySelectorAll('input[name="auction_date"]');
	for (var i = 0; i < auctionRadios.length; i++) {
		auctionRadios[i].addEventListener('click', function () {

			var inspectionRadios = document.querySelectorAll('input[name="inspection_date"]');
			for (var j = 0; j < inspectionRadios.length; j++) {
				inspectionRadios[j].removeAttribute('checked');
			}

			// Submit the form
			document.querySelector('#form-search').submit();
		});
	}
}

if (document.querySelectorAll('input[name="inspection_date"]')) {
	var auctionRadios = document.querySelectorAll('input[name="inspection_date"]');
	for (var i = 0; i < auctionRadios.length; i++) {
		auctionRadios[i].addEventListener('click', function () {

			var inspectionRadios = document.querySelectorAll('input[name="auction_date"]');
			for (var j = 0; j < inspectionRadios.length; j++) {
				inspectionRadios[j].removeAttribute('checked');
			}

			// Submit the form
			document.querySelector('#form-search').submit();
		});
	}
}

// Google Maps - Marker Clustering
async function initMap() {
	const locations = JSON.parse(document.getElementById("rc-map-data").dataset.locations);
	const listings = JSON.parse(document.getElementById("rc-map-data").dataset.listings);
	const pin = document.getElementById("rc-map-data").dataset.pin;
	const cluster = document.getElementById("rc-map-data").dataset.cluster;

	// Request needed libraries.
	const { Map, InfoWindow } = await google.maps.importLibrary("maps");
	const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
		"marker",
	);
	const map = new google.maps.Map(document.getElementById("rc-archive-map"), {
		zoom: 10,
		center: { lat: -27.1998645, lng: 153.1133181 },
		mapId: "5f5a2f0607e69e28e550fb8c",
	});
	const infoWindow = new google.maps.InfoWindow({
		content: "",
		disableAutoPan: true,
	});
	// Add some markers to the map.
	const markers = locations.map((position, i) => {
		const pinGlyph = new google.maps.marker.PinElement({
			glyph: "",
			glyphColor: "white",
			background: "#D6AA2F",
			borderColor: "white",
			scale: 1.2,
		});

		const marker = new google.maps.marker.AdvancedMarkerElement({
			position,
			content: document.createElement('div'), // Create a div to hold the image
		});

		const image = document.createElement('img');
		image.src = pin;
		image.style.width = '65px'; // Adjust the size as needed
		image.style.height = '64px'; // Adjust the size as needed

		marker.content.appendChild(image);

		let content = "";
		content += '<a href="' + listings[i]['url'] + '" class="text-decoration-none">';
		content += '<div class="mw-300">';
		content += listings[i]['image_element'];
		content += '<h5 class="fs-3 text-dark">' + listings[i]['address'] + '</h5>';
		if (listings[i]['price'] !== false) {
			content += '<p class="fs-4 text-dark">' + listings[i]['price'] + '</p>';
		}
		if (listings[i]['features']) {
			content += '<hr class="border-gray">';
			content += '<div class="listing-features justify-content-center d-flex align-items-center cg-24">';
			const features = listings[i]['features'];
			for (const key in features) {
				content += '<div class="feature d-flex flex-column align-items-center rg-16">';
				content += `<span><img src="/app/themes/placepeninsula/media/${key.toLowerCase()}-dark.svg" alt="Icon for listing ${key}" class=""></span>`;
				content += `<span>${features[key]}</span>`;
				content += '</div>';
			}
			content += '</div>';
		}
		content += '</div>';
		content += '</a>';

		// markers can only be keyboard focusable when they have click listeners
		// open info window when marker is clicked
		marker.addListener("click", () => {
			infoWindow.setContent(content);
			infoWindow.open(map, marker);
		});
		return marker;
	});

	const renderer = {
		render: function ({ count, position }) {
			return new google.maps.Marker({
				label: { text: count.toString(), color: 'white', fontSize: '14px', height: "40px", width: "40px" },
				position,
				icon: cluster,
				height: 40,
				width: 40,
			});
		},
	};

	// Add a marker clusterer to manage the markers.
	const markerCluster = new MarkerClusterer({
		map, markers,
		renderer,
	});
}

if (document.getElementById("rc-archive-map")) {
	initMap();
}